<template>
<b-container fluid>
    <b-row>
        <b-col cols=6>
            <card>
                <div class="dropDown">
                <TableActionHeader 
                    ref="actionHeader" 
                    v-on:filterChange="onFilterChange" 
                    v-on:newItem="onNewItem"
                    :searchInput=false />
                </div>
                
                <ReplacementRuleConfigTable @selectItem="onRowSelected" />
                
            </card>
        </b-col>
        <b-col cols=6>
                <InfoCard v-if="action == ''"/>
                <ReplacementRuleConfigForm v-if="action != ''" @itemRemoved="onRuleRemoved" :ruleConfig="currentRuleConfig" :action="action"  />
        </b-col>
    </b-row>
</b-container>
</template>

<script>
const ReplacementRuleConfigTable = () => import('@/components/Realtime/ReplacementRuleConfigTable.vue')
const ReplacementRuleConfigForm = () => import('@/components/Realtime/ReplacementRuleConfigForm.vue')

export default {
    name: 'ReplacementRuleConfigView',
    components: {
        ReplacementRuleConfigTable, ReplacementRuleConfigForm
    },
    data: function() {
        return {
            action:'',
            currentRuleConfig: null
        }
    },
    methods: {
        onFilterChange() {

        },
        onNewItem() {
            this.action='new'
            this.currentRuleConfig = {}
        },
        onRowSelected( item ) {
            console.log("onRowSelected")      
            if( item == undefined ) {
                this.action = ''
            } else {
                this.action ='item'
            }
            this.currentRuleConfig = { ...item }
        },
        onRuleRemoved() {
            this.action=''
            this.currentRuleConfig = {}
        }
    }
}
</script>

<style scoped lang="css">
.dropDown {
    position: absolute;
    right: 1em;
}
</style>